import styles from './ProjectsGallery.module.scss'
import Image from 'next/image'
import Link from 'next/link'
import { motion } from 'framer-motion'
import { imgUrl } from '@bww/beke-lib/sanity-client'

const imgWrapperVariants = {
  hover: { scale: 0.96, transition: { duration: 2 } },
}

const infoVariants = {
  initial: { y: '30%', opacity: 0 },
  hover: { y: '0', opacity: 1, transition: { duration: 0.4 } },
}

export default function Project({ slug, title, heroImg }) {
  return (
    <Link href={`/projects/${slug}`} legacyBehavior passHref={true}>
      <motion.a
        initial="initial"
        whileHover="hover"
        className={styles.project}
        transition={{ staggerChildren: 0.1, staggerDirection: -1 }}
      >
        <motion.div
          variants={infoVariants}
          className={styles.project__infoContainer}
        >
          <h2 className={styles.title}>{title}</h2>
        </motion.div>
        <motion.div variants={imgWrapperVariants} className={styles.imgWrapper}>
          <Image
            className={styles.project__featuredImg}
            src={imgUrl(heroImg).width(1024).url()}
            alt={title}
            style={{ objectFit: 'cover' }}
            // placeholder={heroImg?.lqip ? 'blur' : undefined}
            // blurDataURL={heroImg?.lqip}
            fill
          />
        </motion.div>
      </motion.a>
    </Link>
  )
}
